export const environment = {
  envName: 'Dev',
  production: false,
  apiURL: 'https://dcs6mmcpxh.execute-api.ap-south-1.amazonaws.com/v1',
};
